import React from "react";
import "../../../StyleSheet/AppComponent/Popup/Delete.scss";
import DeleteImg from "../../../Assets/AppComponent/Images/delete2.jpg";
const Delete = (props) => {
  const { show, setShow, handleConfirmDelete, selectedData } = props;
  return (
    show && (
      <div className="DeletePopUp">
        <div className="DeleteClose">
          <div className="DeleteOutter">
            <div className="DeletePart">
              <div className="XMarks">
                {/* <i class="fa-solid fa-triangle-exclamation"></i> */}
                <img src={DeleteImg} />
              </div>
            </div>
            <div className="DeleteText">
              <p>Do You Want to Delete the Data ?</p>
            </div>
            <div className="DeleteButton">
              <button
                className="DeleteCancel"
                onClick={() => {
                  setShow(false);
                }}
              >
                Cancel
              </button>
              <button
                className="DeleteSave"
                onClick={() => handleConfirmDelete(selectedData)}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default Delete;
